import { Button as BlazeButton } from 'blaze-ui/Button'
import { useRef } from 'react'
import { Comment } from 'types'
import { useCollabItemContext } from 'components/CollabItem/CollabItem'
import Styles from './CommentFooter.module.scss'
import { EditorView } from 'prosemirror-view'
import { CommentInput } from 'common/Prose/Toolbar/MobileWriterFormatBar/CommentInput'

interface Props {
  comment: Comment
  view: EditorView
}

export const CommentFooter = ({ comment, view }: Props) => {
  const { isReplying, setIsReplying } = useCollabItemContext()
  const createReplyFormInputRef = useRef<HTMLTextAreaElement>(null)

  return (
    <div className={Styles.container}>
      {isReplying ? (
        <CommentInput view={view} commentable_id={comment.id} onSuccess={() => setIsReplying(false)} />
      ) : (
        <BlazeButton
          fullWidth
          onPress={() => {
            setIsReplying(true)
            setTimeout(() => createReplyFormInputRef.current?.focus(), 250)
          }}
        >
          Write a Reply
        </BlazeButton>
      )}
    </div>
  )
}
